import { render } from "./ProjectDetail.vue?vue&type=template&id=13074070&scoped=true&class=bgcc-riba"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=13074070&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-13074070"

export default script